<template>
  <div class="blk_fusion">
    <a href="/" class="btn btn_photo_reserve">
      <p class="reserve_text">ただいま<span class="clinic_state">{{ isOpen ? '診療中' : '休診中' }}</span><br><span class="reserve_emphasis"><span class="w320_on"><i class="icon-envelope"></i></span>お問い合わせ<span class="w320_off">はこちら</span></span></p>
      <img class="photo" src="/assets/img/common/img_doctor.png">
    </a>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Fusion',
  props: {
    msg: String
  },
  computed: {
    ...mapState([
      'isOpen'
    ])
  },
  mounted () {
    //console.log('mounted:', this.isOpen);
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
